export const foundationSections = [
  { id: 'colors', title: 'Colors', description: 'Palette + semantic roles.', wide: true },
  { id: 'typography', title: 'Typography', description: 'Type scale + roles.', wide: true },
  { id: 'spacing', title: 'Spacing', description: 'Spacing + sizing scale.', wide: true },
  { id: 'radius', title: 'Radius', description: 'Corner radius scale.' },
  { id: 'elevation', title: 'Elevation', description: 'Shadow + depth levels.' },
  { id: 'layout', title: 'Layout', description: 'Grid + breakpoints.', wide: true },
  { id: 'iconography', title: 'Iconography', description: 'Icons + brand assets.', wide: true },
  { id: 'motion', title: 'Motion', description: 'Durations + easing.', wide: true },
];

export const componentSections = [
  { id: 'buttons', title: 'Button', description: 'Button variants + states.' },
  { id: 'button-groups', title: 'Button Group', description: 'Connected button sets.' },
  { id: 'links', title: 'Link', description: 'Inline and standalone links.' },
  { id: 'inputs', title: 'Input', description: 'Single-line text inputs.' },
  { id: 'otp-inputs', title: 'Input OTP', description: 'One-time passcode entry inputs.' },
  {
    id: 'email-otp',
    title: 'Email OTP',
    description: 'Composite email verification experience with resend and helper states.',
  },
  { id: 'fields', title: 'Field', description: 'Label + hint + validation wrappers.' },
  { id: 'file-inputs', title: 'File Input', description: 'File upload selectors.' },
  {
    id: 'password-inputs',
    title: 'Password Input',
    description: 'Password fields + strength meter.',
  },
  { id: 'textareas', title: 'Textarea', description: 'Multi-line inputs.' },
  { id: 'selects', title: 'Select', description: 'Dropdown selects.' },
  { id: 'dropdowns', title: 'Dropdown Menu', description: 'Menu + action lists.' },
  { id: 'checkboxes', title: 'Checkbox', description: 'Binary selections.' },
  { id: 'radios', title: 'Radio Group', description: 'Single-choice selections.' },
  { id: 'switches', title: 'Switch', description: 'Toggle controls.' },
  { id: 'cards', title: 'Card', description: 'Surfaces and containers.' },
  { id: 'alerts', title: 'Alert', description: 'Inline feedback states.' },
  { id: 'badges', title: 'Badge', description: 'Status and tags.' },
  { id: 'avatars', title: 'Avatar', description: 'User identity and media.' },
  { id: 'tabs', title: 'Tabs', description: 'Segmented navigation.' },
  { id: 'dialogs', title: 'Dialog', description: 'Modal overlays.' },
  { id: 'toasts', title: 'Toast', description: 'Transient notifications.' },
  { id: 'dividers', title: 'Divider', description: 'Section separation.' },
  { id: 'progress', title: 'Progress', description: 'Progress indicators.' },
  { id: 'list-rows', title: 'List Row', description: 'Settings row patterns.' },
  { id: 'loading', title: 'Loading', description: 'Skeletons + spinners.' },
  { id: 'accordions', title: 'Accordion', description: 'Collapsible content sections.' },
  { id: 'pagination', title: 'Pagination', description: 'Page navigation controls.' },
  { id: 'date-pickers', title: 'Date Picker', description: 'Date selection inputs.' },
  { id: 'carousels', title: 'Carousel', description: 'Scrollable content displays.' },
];

export const webExclusiveSections = [
  { id: 'data-tables', title: 'Data Table', description: 'Selectable data grids with sorting and pagination.' },
  { id: 'area-trend-charts', title: 'Area Trend Chart', description: 'Time-series area charts for operational trends.' },
  { id: 'image-croppers', title: 'Image Cropper', description: 'Image cropping workflows for profile/media uploads.' },
  { id: 'markdown-renderers', title: 'Markdown Renderer', description: 'Styled markdown preview and content rendering.' },
  { id: 'tooltips', title: 'Tooltip', description: 'Contextual helpers.' },
  { id: 'popovers', title: 'Popover', description: 'Floating content panels.' },
  { id: 'breadcrumbs', title: 'Breadcrumbs', description: 'Navigation path trail.' },
  { id: 'context-menus', title: 'Context Menu', description: 'Right-click action menus.' },
];
